import { ProductEnergy } from '../../../../../generated/graphql';
import { ILabel } from '../../../models/common/label.model';
import { IStock } from '../../../models/common/stock.model';
import { Locale } from '../../../models/master/context-info.model';
import { IPDPCalibration } from '../../../models/pdp/pdp-calibration.model';
import { IPDPMedia } from '../../../models/pdp/pdp-media.model';
import { IPDPPPK } from '../../../models/pdp/pdp-ppk.model';
import { IPDPPricing } from '../../../models/pdp/pdp-pricing.model';
import { IPDPPunchoutInfo } from '../../../models/pdp/pdp-punchout-info.model';
import { IPDPStickers } from '../../../models/pdp/pdp-stickers.model';
import { IPDPTitle } from '../../../models/pdp/pdp-title.model';
import { IBasketService } from '../../../services/basket/basket-service';
import { IPricingService } from '../../../services/pricing/pricing-service';
import { IProductService } from '../../../services/product/product-service';

export type PriceAreaProps = {
  labels?: ILabel[] | null;
  allowAddToPartsList: boolean;
  titleArea?: IPDPTitle | null;
  mediaArea?: IPDPMedia | null;
  priceArea: IPDPPricing;
  ppkArea?: IPDPPPK | null;
  calibrationArea?: IPDPCalibration | null;
  onPackagingChange: (stockCode: string) => void;
  onCalibrationChange: (stockCode: string) => void;
  stockArea?: IStock | null;
  punchoutInfoArea: IPDPPunchoutInfo;
  energyArea?: ProductEnergy | null;
  locale: Locale;
  stickersArea: IPDPStickers;
  pricingService: IPricingService;
  selectedPriceBreakIndex?: number;
  euElrProductInformationSheet?: { callNum: number; url?: string };
  onQtyChange: (qty?: number) => void;
  basketService: IBasketService;
  productService?: IProductService;
  onUnavailableEnergyProductInfoSheetBtnClick?: () => void;
};

export type State = {
  quantity: number;
  partLists: {
    listId?: number;
    showConfirmation: boolean;
    listCreated: boolean;
  };
  showAddedToCart: boolean;
  isDropdownOpen: boolean;
  isEnergyModalOpen: boolean;
  isInBasket: boolean;
};

export enum PriceAreaActionType {
  SetPartsListData = 'SetPartsListData',
  AddToPartList = 'AddToPartList',
  AddedToCart = 'AddedToCart',
  CloseConfirmationMessage = 'CloseConfirmationMessage',
  ToggleDropdownOpen = 'ToggleDropdownOpen',
  QtyChanged = 'QtyChanged',
  SetIsEnergyModalOpen = 'SetIsEnergyModalOpen',
}

export type Action =
  | { type: PriceAreaActionType.SetPartsListData; showSelectedList?: boolean }
  | { type: PriceAreaActionType.AddToPartList; id?: number; name?: string; desc?: string }
  | { type: PriceAreaActionType.AddedToCart }
  | { type: PriceAreaActionType.CloseConfirmationMessage }
  | { type: PriceAreaActionType.ToggleDropdownOpen; isOpen: boolean }
  | { type: PriceAreaActionType.QtyChanged; qty: number }
  | { type: PriceAreaActionType.SetIsEnergyModalOpen; isOpen: boolean };
